import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

interface Request {
  fieldId: PilotId;
}

export const deleteDataField = async ({ fieldId }: Request) => {
  return pilot.remove(`document-information-fields/${fieldId}/`);
};
